<script setup>
import { useRouter } from "vue-router";
import IconX from "@components/icons/X.vue";

const props = defineProps({
    title: { type: String, default: "Terms and Conditions" },
    close: { type: Function, default: null },
});

const router = useRouter();

function handleClose() {
    if (props.close) props.close();
    else router.back();
}
</script>

<template>
    <div
        class="legal-panel bg-marine-800 border-marine-500 relative z-100 flex flex-col gap-6 border-l px-6 pt-6"
    >
        <div class="flex items-center justify-between">
            <p class="h6 leading-[0.9] font-bold tracking-tight uppercase">
                {{ title }}
            </p>
            <button
                class="border-marine-600 shadow-marine-600 flex size-8 shrink-0 items-center justify-center rounded-[4px] border-2 bg-yellow-400 shadow-[0_4px_0]"
                @click="handleClose"
            >
                <IconX class="text-marine-600 size-3" />
            </button>
        </div>

        <div class="flex flex-1 flex-col gap-12 overflow-y-auto pb-6">
            <slot>
                <section class="flex flex-col gap-5">
                    <h3 class="body-md leading-[0.8] font-bold uppercase">
                        Acceptance of Terms
                    </h3>
                    <div class="body-sm leading-[1.4] faded-text">
                        <p>
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                            elit. Sed do eiusmod tempor incididunt ut labore et
                            dolore magna aliqua. Ut enim ad minim veniam, quis
                            nostrud exercitation ullamco laboris nisi ut aliquip
                            ex ea commodo consequat.
                        </p>
                        <p class="mt-4">
                            Duis aute irure dolor in reprehenderit in voluptate
                            velit esse cillum dolore eu fugiat nulla pariatur.
                            Excepteur sint occaecat cupidatat non proident, sunt
                            in culpa qui officia deserunt mollit anim id est
                            laborum.
                        </p>
                    </div>
                </section>

                <section class="flex flex-col gap-5">
                    <h3 class="body-md leading-[0.8] font-bold uppercase">
                        Use of Services
                    </h3>
                    <div class="body-sm leading-[1.4] faded-text">
                        <p>
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                            elit, sed do eiusmod tempor incididunt ut labore et
                            dolore magna aliqua. Ut enim ad minim veniam, quis
                            nostrud exercitation ullamco laboris.
                        </p>
                        <p class="mt-4 font-medium faded-text">
                            Permitted Use
                        </p>
                        <p>
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                            elit. Nulla facilisi. Sed do eiusmod tempor
                            incididunt ut labore et dolore magna aliqua, enim ad
                            minim veniam exercitation ullamco.
                        </p>
                        <p class="mt-4 font-medium faded-text">
                            Restrictions
                        </p>
                        <p>
                            Duis aute irure dolor in reprehenderit in voluptate
                            velit esse cillum dolore eu fugiat nulla pariatur.
                            Excepteur sint occaecat cupidatat non proident, sunt
                            culpa qui officia deserunt mollit.
                        </p>
                        <p class="mt-4 font-medium faded-text">
                            Service Availability
                        </p>
                        <p>
                            Sed ut perspiciatis unde omnis iste natus error sit
                            voluptatem accusantium doloremque laudantium, totam
                            rem aperiam eaque ipsa quae ab illo inventore
                            veritatis et quasi architecto beatae.
                        </p>
                    </div>
                </section>

                <section class="flex flex-col gap-5">
                    <h3 class="body-md leading-[0.8] font-bold uppercase">
                        Content Policy
                    </h3>
                    <p class="body-sm leading-[1.4] faded-text">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                        sed do eiusmod tempor incididunt ut labore et dolore
                        magna aliqua. Ut enim ad minim veniam exercitation
                        ullamco laboris nisi ut aliquip.
                    </p>
                </section>

                <section class="flex flex-col gap-5">
                    <h3 class="body-md leading-[0.8] font-bold uppercase">
                        Privacy &amp; Data
                    </h3>
                    <div class="body-sm leading-[1.4] faded-text">
                        <p>
                            Lorem ipsum dolor sit amet, consectetur adipiscing
                            elit, sed do eiusmod tempor incididunt ut labore et
                            dolore magna aliqua. Ut enim ad minim veniam, quis
                            nostrud exercitation ullamco laboris nisi ut aliquip
                            ex ea commodo consequat duis aute irure.
                        </p>
                        <p class="mt-4 font-medium faded-text">
                            Data Collection
                        </p>
                        <p>
                            At vero eos et accusamus et iusto odio dignissimos
                            ducimus qui blanditiis praesentium voluptatum
                            deleniti atque corrupti quos dolores et quas
                            molestias excepturi sint occaecati cupiditate.
                        </p>
                        <p class="mt-4 font-medium faded-text">
                            Data Retention
                        </p>
                        <p>
                            Similique sunt in culpa qui officia deserunt
                            mollitia animi, id est laborum et dolorum fuga. Et
                            harum quidem rerum facilis est et expedita
                            distinctio. Nam libero tempore soluta nobis.
                        </p>
                        <p class="mt-4 font-medium faded-text">
                            Third-Party Sharing
                        </p>
                        <p>
                            Sed ut perspiciatis unde omnis iste natus error sit
                            voluptatem accusantium doloremque laudantium, totam
                            rem aperiam eaque ipsa quae ab illo inventore
                            veritatis et quasi architecto beatae vitae.
                        </p>
                    </div>
                </section>
            </slot>
        </div>
    </div>
</template>

<style scoped>
.legal-panel {
    grid-column: -11 / -1;
    grid-row: 2 / -1;
    z-index: 2;
    overflow: hidden;
}
</style>
